import type { Normalizer } from '../types';

import { generateValueFromShape } from './generate';
import type { Shape, ShapeValueResult } from './types';

export function createShapeNormalizer<S extends Shape>(shape: S): Normalizer<ShapeValueResult<S>> {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return (value) => generateValueFromShape(shape, value);
}
